import mainService from './mainService';

export function trackByDate(portId: number, data: object) {
    return mainService
        .post(`tracks/${portId}/byDate`, { ...data })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
export function trackByVessel(portId: number, vesselId: number | string, data: object) {
    return mainService
        .post(`tracks/${portId}/byVessel/${vesselId}`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
export function trackByTransit(portId: number, transitId: number, data: object) {
    return mainService
        .post(`tracks/${portId}/byTransit/${transitId}`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
